// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f695c25d","455":"cf7c3296"}[chunkId] + ".chunk.js";
};